export default __webpack_public_path__ + "fonts/iconfont.395953fe3b3591896408d3a63ec24917.svg";